<template>
	<div class="page">
		<el-tabs style="height: 100%;" v-model="activeName" @tab-click="handleClick">
			<el-tab-pane label="会话列表" name="list">
				<chatList ref="listRef" />
			</el-tab-pane>
		
			<el-tab-pane label="历史搜索" name="history">
				<historySearch ref="historyRef" />
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
	import historySearch from './components/historySearch.vue'
	import chatList from './components/chatList.vue'
	export default {
		components: {
			chatList,
			historySearch
		},
		data() {
			return {
				activeName: 'list',
				tabList: [{
						name: 'list',
						label: '会话列表'
					},
					{
						name: 'history',
						label: '搜索会话历史'
					},
				]
			};
		},
		methods: {
			handleClick() {
				this.$nextTick(() => {
					if (this.activeName === 'list') {
						this.$refs.listRef.getList()
					} else if (this.activeName === 'history') {
						this.$refs.historyRef.getList()
					}
				})
			}
		},
	};
</script>

<style lang="scss" scoped>
	::v-deep .el-tabs__item:hover {
		color: #2e4fed;
	}
	
	::v-deep .el-tabs__item.is-active {
		color: #2e4fed;
	}
	
	::v-deep .el-tabs__active-bar {
		background-color: #2e4fed;
	}
	.page {
		background-color: white;
		width: 100%;
		// height: 100%;
		padding: 10px 20px;



	}
</style>